import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { resetPassword } from '../api';
import { forgotPassMutationKeys } from '../data';

import { useNavigate } from 'react-router-dom';

export const useResetPasswordMutation = () => {
  const navigate = useNavigate();
  const mutation = useMutation({
    mutationKey: forgotPassMutationKeys.resetPassword,
    mutationFn: resetPassword,
    onSuccess: (data) => {
      toast.success(data.message);
      navigate('/');
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || 'Something went wrong';
      toast.error(errorMessage);
    },
  });

  return mutation;
};